function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBwossyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "140mm",
    height: "140mm",
    viewBox: "0 0 140 140",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-53.1,-46.1)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffffff",
      strokeWidth: 0.172786
    },
    cx: 123.1,
    cy: 116.1,
    r: 70
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillRule: "evenodd",
      strokeWidth: 0.132291
    },
    d: "M 81.1,110.9 h 50 v 50 H 94.3 A 13.23,13.23 45 0 1 81.1,147.7 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000000",
      fillRule: "evenodd",
      strokeWidth: 0.345716
    },
    r: 25,
    cy: 56.57,
    cx: 155.31,
    transform: "matrix(1,0,0,-1,-49.21,167.998)"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000000",
      fillRule: "evenodd",
      strokeWidth: 0.345716
    },
    r: 25,
    cy: 56.57,
    cx: 155.31,
    transform: "matrix(0,1,1,0,73.99,-19.41)"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0.27114
    },
    cx: 122.6,
    cy: -27.45,
    r: 11,
    transform: "rotate(45)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0.345048
    },
    cx: 159.15,
    cy: -12.8,
    rx: 13.85,
    ry: 14.14,
    transform: "matrix(0.8183,0.5748,-0.5336,0.8457,0,0)"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0.345083
    },
    cx: 188.29,
    cy: -39.95,
    r: 14,
    transform: "rotate(45)"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0.271137
    },
    cx: 219.64,
    cy: -27.45,
    r: 11,
    transform: "rotate(45)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBwossyLogo);
export default __webpack_public_path__ + "static/media/bwossy-logo.79114cebe05b1797d6bbf4c3fde417f6.svg";
export { ForwardRef as ReactComponent };